var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 1.60018C4.47056 1.60018 1.59998 4.47088 1.59998 8.00018C1.59998 11.5296 4.47052 14.4002 7.99998 14.4002C11.5294 14.4002 14.4 11.5295 14.4 8.00018C14.4 4.47076 11.5294 1.60018 7.99998 1.60018ZM7.99998 2.48286C11.0523 2.48286 13.5172 4.94777 13.5172 8.0001C13.5172 11.0523 11.0523 13.5173 7.99998 13.5173C4.94764 13.5173 2.48273 11.0523 2.48273 8.0001C2.48273 4.94777 4.94764 2.48286 7.99998 2.48286ZM7.99998 3.80708C7.75613 3.80708 7.55864 4.00474 7.55864 4.24842V8.0001C7.55864 8.12203 7.60975 8.23055 7.68964 8.31045L10.0275 10.6553C10.1999 10.8277 10.4827 10.8277 10.6552 10.6553C10.8276 10.4829 10.8276 10.2001 10.6552 10.0276L8.44132 7.82075V4.24842C8.44132 4.00458 8.24367 3.80708 7.99998 3.80708H7.99998Z",
    fill: "#686D7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.2b26fef47ace1a03a8ad456e027e6379.svg";
export { ForwardRef as ReactComponent };